<template>
  <div class="videoBox" ref="videoBox" :style="{ display: 'none' }">
    <div :style="{ zoom: videoScreenScale }" class="videoBoxInner" ref="videoBoxInner">
      <!-- <div class="close_btn">
        <a class="selfClose_btn" @click="closeBtn"></a>
      </div>-->
      <easy-cvr
        class="baseVideoSize"
        :vidoeClose="videoClose"
        :videoInfo="videoInfo"
        @playerClose="playerClose"
        v-if="videoType == 'easyCvr'"
      />
      <da-hua
        :vidoeClose="videoClose"
        :videoInfo="videoInfo"
        @playerClose="playerClose"
        v-else-if="videoType == 'daHua'"
      />
      <easy-nvr
        :videoClose="videoClose"
        :videoInfo="videoInfo"
        @playerClose="playerClose"
        v-else-if="videoType == 'easyNvr'"
      />
      <hai-kang
        :videoClose="videoClose"
        :videoInfo="videoInfo"
        @playerClose="playerClose"
        v-else-if="videoType == 'haikang'"
      />
      <haiKangPlatform
        :videoClose="videoClose"
        :videoInfo="videoInfo"
        @playerClose="playerClose"
        v-else-if="videoType == 'hkPlatform'"
      />
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import easyCvr from "./component/easyCvr";
import daHua from "./component/dahua";
import haiKang from "./component/haikang.vue";
import haiKangPlatform from "./component/haiKangPlatform";
import easyNvr from "./component/easyNvr";
import { ref, shallowRef, computed, provide, unref } from "vue";
export default {
  //import引入的组件需要注入到对象中才能使用
  name: "videoBox",
  components: {
    easyCvr,
    daHua,
    haiKang,
    easyNvr,
    haiKangPlatform,
  },
  props: ["nvrInfo"],
  data() {
    //这里存放数据
    return {
      customerId: this.$store.state.customerId,
      videoInfo: "",
      videoType: "",
      videoClose: false,
      videoScreenScale: 1,
      isEasyNvr: bmeConfig.isEasyNvr,
      replay: true,
    };
  },
  provide: function () {
    return {
      //getVideoInfo: computed(() => this.videoInfo),
      //updateVideoInfo: this.updateVideoInfo,

      getVideoClose: computed(() => this.videoClose),
      updateVideoClose: this.updateVideoClose,

      updateVideoType: this.updateVideoType,
    };
  },
  inject: [
    "getShedNvrInfo",
    "updateNvrInfoBox",
    "getBoxInfo",
    "getRoadBoxInfo",
    "getRoadNvrInfo",
    "getShedBarBoxInfo",
    "getShedBarNvrInfo",
  ],
  //计算属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    getRoadNvrInfo: {
      handler(newVal, oldVal) {
        let videoInfo = unref(newVal);
        if (bmeConfig.isEasyCvr) {
          let w = bmeConfig.INIT_WIDTH;
          $(this.$refs.videoPlayerInner)
            .css("left", (w - 1470) / 2 + "px")
            .css("width", "1470px");
          this.videoType = "easyCvr";
        } else if (bmeConfig.isDaHua) {
          let w = bmeConfig.INIT_WIDTH;
          $(this.$refs.videoPlayerInner)
            .css("left", (w - 1208) / 2 + "px")
            .css("width", "1208px");
          this.videoType = "daHua";
        } else if (videoInfo.cameraType === "newEasyNvr" || bmeConfig.isEasyNvr) {
          let w = bmeConfig.INIT_WIDTH;
          $(this.$refs.videoPlayerInner)
            .css("left", (w - 1470) / 2 + "px")
            .css("width", "1470px");
          this.videoType = "easyNvr";
        } else if (this.videoInfo.cameraType === "HKCVR" || bmeConfig.isHKPlatform) {
          this.videoType = "hkPlatform";
          let w = bmeConfig.INIT_WIDTH;
          $(this.$refs.videoPlayerInner)
            .css("left", (w - 1208) / 2 + "px")
            .css("width", "1208px");
        } else {
          this.videoType = "haikang";
          let w = bmeConfig.INIT_WIDTH;
          $(this.$refs.videoPlayerInner)
            .css("left", (w - 1208) / 2 + "px")
            .css("width", "1208px");
        }

        if (
          bmeConfig.hkNvrIpList &&
          bmeConfig.hkNvrIpList.length > 0 &&
          $.inArray(videoInfo.nvrIp, bmeConfig.hkNvrIpList) >= 0
        ) {
          this.videoType = "haikang";
          let w = bmeConfig.INIT_WIDTH;
          $(this.$refs.videoPlayerInner)
            .css("left", (w - 1208) / 2 + "px")
            .css("width", "1208px");
        }

        if (
          bmeConfig.cvrIpList &&
          bmeConfig.cvrIpList.length > 0 &&
          $.inArray(videoInfo.nvrIp, bmeConfig.cvrIpList) >= 0
        ) {
          let w = bmeConfig.INIT_WIDTH;
          $(this.$refs.videoPlayerInner)
            .css("left", (w - 1470) / 2 + "px")
            .css("width", "1470px");
          this.videoType = "easyCvr";
        }

        this.$forceUpdate();
        this.$nextTick(() => {
          this.videoInfo = videoInfo;
          console.log(this.videoInfo);
        });
        //this.videoClose = true;
      },
      deep: true,
    },
    getShedBarNvrInfo: {
      handler(newVal, oldVal) {
        let videoInfo = unref(newVal);
        if (bmeConfig.isEasyCvr || videoInfo.videoType == "easyCvr") {
          let w = bmeConfig.INIT_WIDTH;
          $(this.$refs.videoPlayerInner)
            .css("left", (w - 1470) / 2 + "px")
            .css("width", "1470px");
          this.videoType = "easyCvr";
        } else if (bmeConfig.isDaHua) {
          let w = bmeConfig.INIT_WIDTH;
          $(this.$refs.videoPlayerInner)
            .css("left", (w - 1208) / 2 + "px")
            .css("width", "1208px");
          this.videoType = "daHua";
        } else if (videoInfo.cameraType === "newEasyNvr" || bmeConfig.isEasyNvr) {
          let w = bmeConfig.INIT_WIDTH;
          $(this.$refs.videoPlayerInner)
            .css("left", (w - 1470) / 2 + "px")
            .css("width", "1470px");
          this.videoType = "easyNvr";
        } else if (this.videoInfo.cameraType === "HKCVR" || bmeConfig.isHKPlatform) {
          this.videoType = "hkPlatform";
          let w = bmeConfig.INIT_WIDTH;
          $(this.$refs.videoPlayerInner)
            .css("left", (w - 1208) / 2 + "px")
            .css("width", "1208px");
        } else {
          this.videoType = "haikang";
          let w = bmeConfig.INIT_WIDTH;
          $(this.$refs.videoPlayerInner)
            .css("left", (w - 1208) / 2 + "px")
            .css("width", "1208px");
        }

        if (
          bmeConfig.hkNvrIpList &&
          bmeConfig.hkNvrIpList.length > 0 &&
          $.inArray(videoInfo.nvrIp, bmeConfig.hkNvrIpList) >= 0
        ) {
          this.videoType = "haikang";
          let w = bmeConfig.INIT_WIDTH;
          $(this.$refs.videoPlayerInner)
            .css("left", (w - 1208) / 2 + "px")
            .css("width", "1208px");
        }

        if (
          bmeConfig.cvrIpList &&
          bmeConfig.cvrIpList.length > 0 &&
          $.inArray(videoInfo.nvrIp, bmeConfig.cvrIpList) >= 0
        ) {
          let w = bmeConfig.INIT_WIDTH;
          $(this.$refs.videoPlayerInner)
            .css("left", (w - 1470) / 2 + "px")
            .css("width", "1470px");
          this.videoType = "easyCvr";
        }

        this.$forceUpdate();
        this.$nextTick(() => {
          this.videoInfo = videoInfo;
          console.log(this.videoInfo);
        });
        //this.videoClose = true;
      },
      deep: true,
    },
    getShedNvrInfo: {
      handler(newVal, oldVal) {
        let videoInfo = unref(newVal);
        if (bmeConfig.isEasyCvr) {
          let w = bmeConfig.INIT_WIDTH;
          $(this.$refs.videoPlayerInner)
            .css("left", (w - 1470) / 2 + "px")
            .css("width", "1470px");
          this.videoType = "easyCvr";
        } else if (bmeConfig.isDaHua) {
          let w = bmeConfig.INIT_WIDTH;
          $(this.$refs.videoPlayerInner)
            .css("left", (w - 1208) / 2 + "px")
            .css("width", "1208px");
          this.videoType = "daHua";
        } else if (videoInfo.cameraType === "newEasyNvr" || bmeConfig.isEasyNvr) {
          let w = bmeConfig.INIT_WIDTH;
          $(this.$refs.videoPlayerInner)
            .css("left", (w - 1470) / 2 + "px")
            .css("width", "1470px");
          this.videoType = "easyNvr";
        } else if (this.videoInfo.cameraType === "HKCVR" || bmeConfig.isHKPlatform) {
          this.videoType = "hkPlatform";
          let w = bmeConfig.INIT_WIDTH;
          $(this.$refs.videoPlayerInner)
            .css("left", (w - 1208) / 2 + "px")
            .css("width", "1208px");
        } else {
          this.videoType = "haikang";
          let w = bmeConfig.INIT_WIDTH;
          $(this.$refs.videoPlayerInner)
            .css("left", (w - 1208) / 2 + "px")
            .css("width", "1208px");
        }

        if (
          bmeConfig.hkNvrIpList &&
          bmeConfig.hkNvrIpList.length > 0 &&
          $.inArray(videoInfo.nvrIp, bmeConfig.hkNvrIpList) >= 0
        ) {
          this.videoType = "haikang";
          let w = bmeConfig.INIT_WIDTH;
          $(this.$refs.videoPlayerInner)
            .css("left", (w - 1208) / 2 + "px")
            .css("width", "1208px");
        }

        if (
          bmeConfig.cvrIpList &&
          bmeConfig.cvrIpList.length > 0 &&
          $.inArray(videoInfo.nvrIp, bmeConfig.cvrIpList) >= 0
        ) {
          let w = bmeConfig.INIT_WIDTH;
          $(this.$refs.videoPlayerInner)
            .css("left", (w - 1470) / 2 + "px")
            .css("width", "1470px");
          this.videoType = "easyCvr";
        }

        this.$forceUpdate();
        this.$nextTick(() => {
          this.videoInfo = videoInfo;
          console.log(this.videoInfo);
        });
        //this.videoClose = true;
      },
      deep: true,
    },
    getRoadBoxInfo: {
      handler(newVal, oldVal) {
        this.boxInfoSet = unref(newVal);
        if (this.boxInfoSet) {
          $(this.$refs.videoBox).css("background", "rgba(0,0,0,0)");
          $(this.$refs.videoBox)
            .css("left", this.boxInfoSet.left)
            .css("top", this.boxInfoSet.top)
            .css("width", this.boxInfoSet.width || 400 + "px")
            .css("height", this.boxInfoSet.height || 240 + "px");
          this.$forceUpdate();
        }
      },
      deep: true,
    },
    getShedBarBoxInfo: {
      handler(newVal, oldVal) {
        this.boxInfoSet = unref(newVal);
        if (this.boxInfoSet) {
          $(this.$refs.videoBox).css("background", "rgba(0,0,0,0)");
          $(this.$refs.videoBox)
            .css("left", this.boxInfoSet.left)
            .css("top", this.boxInfoSet.top)
            .css("width", this.boxInfoSet.width || 400 + "px")
            .css("height", this.boxInfoSet.height || 240 + "px");
          this.$forceUpdate();
        }
      },
      deep: true,
    },
    getBoxInfo: {
      handler(newVal, oldVal) {
        this.boxInfoSet = unref(newVal);
        if (this.boxInfoSet) {
          $(this.$refs.videoBox).css("background", "rgba(0,0,0,0)");
          $(this.$refs.videoBox)
            .css("left", this.boxInfoSet.left)
            .css("top", this.boxInfoSet.top)
            .css("width", this.boxInfoSet.width || 400 + "px")
            .css("height", this.boxInfoSet.height || 240 + "px");
        }
      },
      deep: true,
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    let that = this;
    let w = bmeConfig.INIT_WIDTH;
    let h = bmeConfig.INIT_HEIGHT;
    this.width1 = w * 0.9 * 0.3;
    this.width3 = w * 0.9 * 0.2;
    this.width4 = w * 0.9 * 0.2;
    $(this.$refs.videoBoxInner)
      // .css("background", "#000")
      .css("position", "absolute")
      .css("zIndex", 1000);
    this.videoScreenScale = bmeConfig.videoScreenScale ? bmeConfig.videoScreenScale : 1;
    if (bmeConfig.styleType === "typeGreen") {
      $(this.$refs.videoBoxInner).css("background", "#0e524c");
    } else if (bmeConfig.styleType === "typeDark") {
      $(this.$refs.videoBoxInner).css("background", "#000000bf");
    }

    $(this.$refs.videoBox).fadeOut(0);
  },
  //方法集合
  methods: {
    updateVideoInfo(val) {
      this.videoInfo = val;
    },
    closeBtn() {
      this.updateVideoType();
      this.$store.commit("changeOpenVideo", "close");
    },
    updateVideoType() {
      if (this.videoCloseTimer) {
        clearTimeout(this.videoCloseTimer);
      }
      this.videoCloseTimer = setTimeout(() => {
        this.videoClose = new Date().getTime();
        this.$forceUpdate();
        this.$store.commit("changeVideoPlayerSwitch", "close");
        this.$store.commit("changeRoadVideoBoxSwitch", "close");
      }, 500);
    },
    playerClose() {
      this.videoType = "";
      this.$forceUpdate();
      this.$nextTick(() => {
        this.updateNvrInfoBox && this.updateNvrInfoBox("");
      });
      this.$nextTick(() => {
        this.updateNvrInfoBox && this.updateNvrInfoBox("");
      });
      this.$store.commit("changeVideoPlayerSwitch", "close");
      this.$store.commit("changeRoadVideoBoxSwitch", "close");
      this.$store.commit("changeOpenVideo", "close");
    },
  },
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss">
.videoBox {
  .el-tabs__item {
    font-size: 24px;
    font-family: "fontNormal";
    color: #fff;
  }

  .item_ul {
    width: 100%;
    height: 100%;
    overflow: auto;
  }

  .item_li {
    width: 600px;
    height: 300px;
    background-size: 600px 300px;
    background-position: center;
    background-repeat: no-repeat;
    background-image: none;
    margin-right: 20px;
    margin-bottom: 20px;
    float: left;
    position: relative;
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
      display: block;
    }

    p {
      position: absolute;
      bottom: 0;
      width: 100%;
      line-height: 50px;
      text-align: center;
      background: rgba(0, 0, 0, 0.8);
      font-size: 24px;
    }
  }
}
.baseVideoSize {
  width: 100% !important;
  height: 100% !important;
  .centeredVideo {
    width: 100% !important;
    height: 100% !important;
  }
  .plugin {
    width: 100% !important;
    height: 100% !important;
  }
  .nvr-player {
    padding-top: 0 !important;
  }
}
</style>
<style scoped lang="scss">
.close-div {
  position: absolute;
  top: 120px;
  right: 340px;
  background-color: #060606;
  width: 90px;
  height: 50px;
  background-image: url("./img/closeBtn.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  z-index: 99;
}
.md-modal {
  z-index: 10001;
}
.md-content {
  padding: 75px 100px;
  // background: rgba(0, 0, 0, 0.75);
  box-shadow: 0px 0px 10px 5px #ccc;
}
.pointerEventAll {
  pointer-events: all;
}

.totalNum {
  color: #f5a623;
  height: 50px;
  line-height: 50px;
  display: inline-block;
  vertical-align: middle;
  position: relative;
  margin-left: 15px;
}

.totalTitle {
  vertical-align: middle;
  line-height: 50px;
  height: 50px;
  font-size: 32px;
}
.num {
  color: #99f5ff;
  font-size: 30px;
  margin-left: 15px;
  line-height: 50px;
  height: 50px;
  position: relative;
  display: inline-block;
}

.close_btn {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 99;
}

.videoBox_title {
  position: relative;
  width: 100%;
  text-align: center;
  font-size: 32px;
  font-family: "fontNormal";
  font-weight: 500;
  color: #f5a623;
}

.videoBox {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  top: 0;
  left: 0;
  z-index: 9999;
}

.videoBoxInner {
  pointer-events: all;
  width: 100%;
  height: 100%;
  z-index: 9999;
  box-shadow: 0px 10px 20px 0px rgba(74, 144, 226, 0.31);
  border-radius: 2px;
  position: absolute;
}

.container {
  position: absolute;
  height: 720px;
  width: 100%;
  margin-top: 55px !important;
  padding: 10px 32px 20px 32px !important;
}

.searchTitle {
  display: inline-block;
  span {
    font-size: 16px;
    font-family: "fontNormal";
    color: #99f5ff;
  }
}

.self_btn {
  background-image: url("img/btn.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  text-align: center;
  box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.22);
  border-radius: 2px;
  width: 90px;
  height: 45px;
  line-height: 40px;
  display: inline-block;
  cursor: pointer;
}

.selfClose_btn {
  background-image: url("img/closeBtn.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  text-align: center;
  box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.22);
  border-radius: 2px;
  width: 90px;
  height: 45px;
  line-height: 40px;
  display: inline-block;
  cursor: pointer;
}

/*.self_btn:hover{
 background-image: url("img/btn_click.png");
}*/

.self_btn:active {
  background-image: url("img/btn_click.png");
}

.dot1 {
  font-size: 60px;
  color: #99f5ffff;
  display: inline-block;
  vertical-align: middle;
  height: 40px;
  line-height: 30px;
}

.dot2 {
  font-size: 60px;
  color: #4d4d4dff;
  display: inline-block;
  vertical-align: middle;
  height: 40px;
  line-height: 30px;
  margin-left: 20px;
}

.dot3 {
  font-size: 60px;
  color: #ff7f7fff;
  display: inline-block;
  vertical-align: middle;
  height: 40px;
  line-height: 30px;
  margin-left: 20px;
}

.dot1-title {
  font-size: 16px;
  font-family: "fontNormal";
  color: #c8dde1ff;
  display: inline-block;
  line-height: 50px;
  height: 40px;
}
</style>
